exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".masraf-merkezi-report-table[data-v-1af3f432],.masraf-merkezi-report-table>*[data-v-1af3f432]{width:100%}", ""]);

// exports
